export const myNotificationsTranslations = {
  main_title: 8222,
  sub_title: 8174,
  consents_title: 8173,
  consents_disclaimer: 8260,
  consent_delete_description: 8171,
  consent_delete: 8172,
  consent_delete_success: 8168,
  consent_sms_add_success: 8181,
  consent_sms_update_success: 8191,
  consent_push_add_success: 8312,
  consent_push_update_success: 8376,
  consent_push_not_active_message: 8377,
  consent_push_browser_allow_message: 8378,
  sms_text: 8188,
  sms_phone_label: 8175,
  push_name: 8366,
  push_text: 8310,
  add_sms_title: 8176,
  add_push_title: 8307,
  edit_push_title: 8365,
  push_token_exists_info: 8313,
  new_phone_number: 8185,
  previous_phone_number: 8186,
  change_phone_number: 8187,
  sms_disclaimer: 8260,
  verification_code: 8282,
  verification_code_success: 8286,
  verification_code_message: 8314,
  refresh_page: 8385,
  send_code: 8283,
  code_info: 8284,
  no_data: 8196,
  phone_number_info: 8198,
  validation_error: 8206,
  email_invalid: 7758,
  must_be_equal: 7681,
  must_be_filled: 5949,
  must_be_unique: 8105,
  edit: 8184,
  save: 8177,
  cancel: 8167
};

export type MyNotificationTranslation = {
  readonly [T in keyof typeof myNotificationsTranslations]: string
};

export const form = {
  sms: {
    previousPhoneNumber: 'previousPhoneNumber',
    phoneNumber: 'token',
    verificationCode: 'verificationCode'
  },
  push: {
    name: 'name'
  }
};

export const countdownTimer = {
  intervalTime: 1000,
  value: 60
};

export const phoneNumberMinLength = 4;
export const pushNameMinLength = 3;
export const pushNameMaxLength = 60;
